import { useDisplayedErrors } from '../redux/reducer/errorHandlerReducer';
import { useEffect, useState } from 'react';
import { useModal } from './useModal';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { inactiveGameModalFound, inactiveGameModalNotFound } from '../constants/copyright-modals';

export default function useErrorHandler() {
  const [currentDisplayed, setCurrentDisplayed] = useState(null);
  const { displayErrors } = useDisplayedErrors();
  const { addModal } = useModal();

  useDeepCompareEffect(() => {
    if (!displayErrors) return;
    setCurrentDisplayed(displayErrors[0]);
  }, [displayErrors]);

  useEffect(() => {
    if (!currentDisplayed) return;

    if (currentDisplayed?.name === 'Found') {
      addModal({
        type: 'errorModal',
        props: {
          error: currentDisplayed,
          ...inactiveGameModalFound,
        },
      });
    } else if (currentDisplayed?.name === 'notFound') {
      addModal({
        type: 'errorModal',
        props: {
          error: currentDisplayed,
          ...inactiveGameModalNotFound,
        },
      });
    }
  }, [currentDisplayed]);
}
